import { Link } from "react-router";
import { EigenerKopf } from "../components/shell/Logo";
import { Icon } from "../components/Icon";
import { t } from "../lib/sprache";
import { arbeitsbereiche, bereichName, wechselSatz, zuletztGenutzt } from "./bereichswahl-model";
import type { Account } from "./session";

function gemerkt(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * S2 (Konto-Prüfung 03.11.2026, 0540): Wer ein eigenes Creator-Konto und ein Creator-Profil bei einer Agentur hat, wählt nach der
 * Anmeldung, wo es weitergeht. Beide Bereiche sind getrennt; gewechselt wird später oben im Kopf über die Auswahl „Mein Konto“
 * bzw. „Bei <Agentur>“ (der Satz nennt genau diese Beschriftung, Praxistest 04.11.2026).
 */
export function Bereichswahl({ account, zuletzt }: { account: Account; zuletzt: string | null }) {
  const bereiche = arbeitsbereiche(account);
  const org = { team: gemerkt("tk-org"), creator: gemerkt("tk-talent-org") };
  return (
    <>
      <EigenerKopf />
      <main id="main" className="content tk-bereichswahl">
        <div className="pagehead">
          <div>
            <div className="eyebrow">{t("Anmeldung", "Sign-in")}</div>
            <h1>{t("Wo möchtest du weiterarbeiten?", "Where would you like to continue?")}</h1>
          </div>
        </div>
        <nav className="panel stack tk-menu" aria-label={t("Bereich wählen", "Choose workspace")}>
          {bereiche.map((b) => (
            <Link key={`${b.art}-${b.orgId}`} to={b.to} className="task">
              <span className="row">
                <Icon name={b.art === "eigen" ? "user" : "users"} />
                <span className="stack tk-bereichswahl-text">
                  <strong>{bereichName(b, t)}</strong>
                  <small className="muted">{b.art === "eigen"
                    ? t(`Dein eigenes Creator-Konto ${b.name}: Deals, Verträge und Rechnungen an Marken.`, `Your own creator account ${b.name}: deals, contracts and invoices to brands.`)
                    : t("Dein Creator-Portal bei dieser Agentur: Kooperationen, Rechnungen an die Agentur und Nachrichten.", "Your creator portal at this agency: collaborations, invoices to the agency and messages.")}</small>
                </span>
              </span>
              <span className="row">
                {zuletztGenutzt(b, zuletzt, org) && <span className="pill">{t("Zuletzt genutzt", "Last used")}</span>}
                <span aria-hidden="true">›</span>
              </span>
            </Link>
          ))}
        </nav>
        <p className="muted">{t("Die Bereiche sind getrennt: Die Agentur sieht nichts aus deinem eigenen Konto, und Rechnungen laufen je Bereich mit eigenem Absender und eigenen Nummern.",
          "The workspaces are separate: the agency sees nothing from your own account, and invoices run per workspace with their own sender and numbers.")} {wechselSatz(bereiche, t)}</p>
      </main>
    </>
  );
}
